import React from 'react';
import styles from "./styles.module.css";
import Header from '../header'
import { IoLogoWhatsapp, IoLogoInstagram } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import Footer from '../footer';

const Contato: React.FC = (props) => {

    return (
        <div>
            <div className={styles.containermenu}>
                <Header />
            </div>
            <h1>CONTATO NANDA CONFEITOS</h1>
            <div className={styles.container}>


                <a href="https://wa.me/+556296874973" rel="noreferrer"  className={styles.stretch}>
                    <div className={styles.brackgroundGreen}>
                        <IoLogoWhatsapp size='60' color="green" />
                        <label className={styles.labelWhats}>(62) 9 9687-4973</label>
                    </div>
                </a>


                <a href="https://instagram.com/nandaconfeitos?utm_medium=copy_link" rel="noreferrer"  className={styles.stretch}>
                    <div className={styles.backgroundPink}>
                        <IoLogoInstagram size='60' color="#D02090" />
                        <label className={styles.labelWhats}>@nandaconfeitos</label>
                    </div>
                </a>


                <a href="mailto:contato@nandaconfeitos.cloudns.nz" rel="noreferrer" className={styles.stretch}>
                    <div className={styles.backgroundYellow}>
                        <MdEmail size='60' color="#FFA500" />
                        <label className={styles.labelWhats}>contato@nandaconfeitos.cloudns.nz</label>
                    </div>
                </a>


            </div>
            <Footer/>
        </div>

    )

}

export default Contato;